import { render, staticRenderFns } from "./RoleWeiXin.vue?vue&type=template&id=c408b8f6"
import script from "./RoleWeiXin.vue?vue&type=script&lang=js"
export * from "./RoleWeiXin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports